/** Figma greeting card (LG/XL carousel). */
export const GREETING_CARD_WIDTH_PX = 232;
export const GREETING_CARD_HEIGHT_PX = 320;

/** Figma space card — identical across XS, SM, MD, LG, XL. */
export const SPACE_CARD_WIDTH_PX = 262;
export const SPACE_CARD_HEIGHT_PX = 319;
export const SPACE_CARD_GAP_PX = 16;
export const SPACE_CARD_BORDER_RADIUS = '24px';
/** Figma space card surface — var(--AulaSky-900). Identical in light and dark. */
export const SPACE_CARD_BG = 'rgba(0, 91, 108, 1)';

/** Inner content frame inside space card padding. */
export const SPACE_CARD_INNER_WIDTH_PX = 231;
export const SPACE_CARD_INNER_HEIGHT_PX = 271;
export const SPACE_CARD_PADDING_Y_PX = 24;
export const SPACE_CARD_PADDING_X_PX = 15.5;

export const SPACE_CARD_HEADER_ROW_HEIGHT_PX = 40;
export const SPACE_CARD_HEADER_ROW_GAP_PX = 16;

/** Title, description, and progress — excludes resume button. */
export const SPACE_CARD_BODY_BLOCK_HEIGHT_PX = 217;
export const SPACE_CARD_BODY_BLOCK_GAP_PX = 8;

/** Title, description, and progress bar section. */
export const SPACE_CARD_TEXT_BLOCK_HEIGHT_PX = 169;
export const SPACE_CARD_TEXT_BLOCK_GAP_PX = 11;
export const SPACE_CARD_TITLE_HEIGHT_PX = 64;
export const SPACE_CARD_DESCRIPTION_HEIGHT_PX = 42;

export const SPACE_CARD_TITLE_FONT_SIZE = '1.25rem';
export const SPACE_CARD_TITLE_FONT_WEIGHT = 500;
export const SPACE_CARD_TITLE_LINE_HEIGHT = '160%';
export const SPACE_CARD_TITLE_LETTER_SPACING = '0.15px';

export const SPACE_CARD_DESCRIPTION_FONT_SIZE = '0.875rem';
export const SPACE_CARD_DESCRIPTION_FONT_WEIGHT = 400;
export const SPACE_CARD_DESCRIPTION_LINE_HEIGHT = '150%';
export const SPACE_CARD_DESCRIPTION_LETTER_SPACING = '0.17px';
export const SPACE_CARD_DESCRIPTION_COLOR = 'rgba(255, 255, 255, 1)';

export const SPACE_PROGRESS_BAR_HEIGHT_PX = 9;
export const SPACE_PROGRESS_LABEL_HEIGHT_PX = 21;
export const SPACE_PROGRESS_LABEL_FONT_SIZE = '0.875rem';
export const SPACE_PROGRESS_LABEL_LINE_HEIGHT = '150%';
export const SPACE_PROGRESS_LABEL_LETTER_SPACING = '0.17px';
export const SPACE_CARD_PROGRESS_SECTION_GAP_PX = 10;
export const SPACE_CARD_PROGRESS_SECTION_HEIGHT_PX =
  SPACE_PROGRESS_BAR_HEIGHT_PX +
  SPACE_CARD_PROGRESS_SECTION_GAP_PX +
  SPACE_PROGRESS_LABEL_HEIGHT_PX;

/** Figma educator engagement link — icon + "X% Active Students" + EastOutlined arrow. */
export const SPACE_ENGAGEMENT_LINK_WIDTH_PX = 214;
export const SPACE_ENGAGEMENT_LINK_HEIGHT_PX = 40;
export const SPACE_ENGAGEMENT_CONTENT_WIDTH_PX = 174;
export const SPACE_ENGAGEMENT_CONTENT_HEIGHT_PX = 24;
export const SPACE_ENGAGEMENT_CONTENT_GAP_PX = 8;
export const SPACE_ENGAGEMENT_ICON_SIZE_PX = 24;
export const SPACE_ENGAGEMENT_TEXT_WIDTH_PX = 142;
export const SPACE_ENGAGEMENT_TEXT_HEIGHT_PX = 21;
export const SPACE_ENGAGEMENT_TEXT_FONT_SIZE = '0.875rem';
export const SPACE_ENGAGEMENT_TEXT_FONT_WEIGHT = 400;
export const SPACE_ENGAGEMENT_TEXT_LINE_HEIGHT = '150%';
export const SPACE_ENGAGEMENT_TEXT_LETTER_SPACING = '0.17px';
export const SPACE_ENGAGEMENT_TEXT_COLOR = 'rgba(255, 255, 255, 1)';

/** Figma educator empty-space prompt — shown when the space has no page/material. */
export const SPACE_EMPTY_PROMPT_WIDTH_PX = 231;
export const SPACE_EMPTY_PROMPT_HEIGHT_PX = 36;
export const SPACE_EMPTY_PROMPT_GAP_PX = 8;
export const SPACE_EMPTY_PROMPT_ICON_SIZE_PX = 20;
export const SPACE_EMPTY_PROMPT_TEXT_WIDTH_PX = 195;
export const SPACE_EMPTY_PROMPT_TEXT_HEIGHT_PX = 21;
export const SPACE_EMPTY_PROMPT_TEXT_FONT_SIZE = '0.875rem';
export const SPACE_EMPTY_PROMPT_TEXT_FONT_WEIGHT = 400;
export const SPACE_EMPTY_PROMPT_TEXT_LINE_HEIGHT = '150%';
export const SPACE_EMPTY_PROMPT_TEXT_LETTER_SPACING = '0.17px';
/** Figma var(--text-secondary). */
export const SPACE_EMPTY_PROMPT_TEXT_COLOR = 'rgba(255, 255, 255, 0.7)';
export const SPACE_EMPTY_PROMPT_EDUCATOR_LABEL = 'Start by adding a new page';
export const SPACE_EMPTY_PROMPT_STUDENT_LABEL = 'No materials found';

/** Figma --text-_states-focus */
export const SPACE_CARD_ICON_THUMBNAIL_BG = 'rgba(255, 255, 255, 0.12)';
/** MUI IconButton Color="Default" on dark — not full white. */
export const SPACE_CARD_ICON_GLYPH_COLOR = 'rgba(255, 255, 255, 0.56)';

export const SPACE_CARD_SHADOW =
  '0px 4px 16px rgba(0, 0, 0, 0.12), 0px 1px 4px rgba(0, 0, 0, 0.08)';

export const SPACE_CARD_ICON_BUTTON_SIZE_PX = 36;
export const SPACE_CARD_ICON_BUTTON_PADDING_PX = 6;
export const SPACE_CARD_ICON_BUTTON_RADIUS = '100px';
export const SPACE_CARD_ICON_GLYPH_SIZE_PX = 24;
export const SPACE_CARD_ICON_FOCUS_RIPPLE_SIZE_PX = 36;
export const SPACE_CARD_ICON_FOCUS_RIPPLE_BG = 'rgba(255, 255, 255, 0.12)';

export const SPACE_META_PILL_HEIGHT_PX = 24;
export const SPACE_META_PILL_RADIUS = '100px';
/** MUI Chip size="small" — 0 vertical, 8px horizontal breathing room. */
export const SPACE_META_PILL_PADDING = '0 6px';
export const SPACE_META_PILL_FONT_SIZE = '0.875rem';
/** Single-line chip: match 24px height (150% line-height was overflowing the box). */
export const SPACE_META_PILL_LINE_HEIGHT = `${SPACE_META_PILL_HEIGHT_PX}px`;
export const SPACE_META_PILL_LETTER_SPACING = '0.17px';
export const SPACE_META_PILL_GAP_PX = 4;
export const SPACE_META_PILLS_CONTAINER_WIDTH_PX = 179;
export const SPACE_META_PILLS_CONTAINER_HEIGHT_PX = 24;

/** Figma resume button — Medium / Outlined. */
export const SPACE_RESUME_BUTTON_HEIGHT_PX = 36;
export const SPACE_RESUME_BUTTON_PADDING = '6px 16px';
export const SPACE_RESUME_BUTTON_FONT_SIZE = '0.875rem';
export const SPACE_RESUME_BUTTON_LINE_HEIGHT = '150%';
export const SPACE_RESUME_BUTTON_LETTER_SPACING = '0.17px';
export const SPACE_RESUME_BUTTON_ICON_SIZE_PX = 20;
export const SPACE_RESUME_BUTTON_GAP_PX = 8;

/** Figma Frame 14757 — Space widget container (XL/LG). Width is 100% of parent. */
export const SPACE_WIDGET_CONTAINER_MIN_HEIGHT_PX = 402;
export const SPACE_WIDGET_CONTAINER_BORDER_RADIUS = '24px';
export const SPACE_WIDGET_CONTAINER_PADDING = '16px';
export const SPACE_WIDGET_CONTAINER_GAP_PX = 10;
export const SPACE_WIDGET_CONTAINER_BORDER_LIGHT =
  '1px solid rgba(35, 31, 41, 0.16)';
export const SPACE_WIDGET_CONTAINER_BORDER_DARK =
  '1px solid rgba(255, 255, 255, 0.12)';
export const SPACE_WIDGET_CONTAINER_BG_LIGHT = '#FFFFFF';
/** Figma dark — widget frame surface var(--surface-Bright, rgba(58, 52, 68, 1)). */
export const SPACE_WIDGET_CONTAINER_BG_DARK = 'rgba(58, 52, 68, 1)';

/** Min role-filtered cards before auto-prefetch stops (carousel can scroll). */
export const SPACE_WIDGET_PREFETCH_MIN_VISIBLE_CARDS_LG = 5;
export const SPACE_WIDGET_PREFETCH_MIN_VISIBLE_CARDS_SM = 3;

/** Skeleton card count while initial spaces API load is in flight (Figma loading state). */
export const SPACE_WIDGET_SKELETON_CARD_COUNT_LG = 4;
export const SPACE_WIDGET_SKELETON_CARD_COUNT_SM = 3;

/** Skeleton shimmer on teal space cards — works in light and dark app chrome. */
export const SPACE_CARD_SKELETON_SURFACE = 'rgba(255, 255, 255, 0.22)';

/** Figma empty state — compact "No module found" card (greeting moves above on all breakpoints). */
export const SPACE_WIDGET_EMPTY_STATE_MIN_HEIGHT_PX = 85;
export const SPACE_WIDGET_EMPTY_STATE_TITLE = 'No module found';
export const SPACE_WIDGET_EMPTY_STATE_SUBTITLE =
  "You're not enrolled in any space.";
/** Figma var(--surface-Mid) — light. */
export const SPACE_WIDGET_EMPTY_STATE_BG_LIGHT = 'rgba(248, 247, 249, 1)';
/** Figma var(--surface-Mid) — dark. */
export const SPACE_WIDGET_EMPTY_STATE_BG_DARK = 'rgba(35, 31, 41, 1)';
